/**
 * 待清理
 * 首页优化 无需加载未使用资源
 */

// import Swipeout from '@/components/base-ui/swipeout/swipeout.vue';
// import SwipeoutItem from '@/components/base-ui/swipeout/swipeout-item.vue';
// import SwipeoutButton from '@/components/base-ui/swipeout/swipeout-button.vue';
// import QuickMenu from 'components/base-ui/quick-menu.vue';
const QuickMenu = () => import('components/base-ui/quick-menu.vue');
const Swipeout = () => import('components/base-ui/swipeout/swipeout.vue');
const SwipeoutItem = () => import('components/base-ui/swipeout/swipeout-item.vue');
const SwipeoutButton = () => import('components/base-ui/swipeout/swipeout-button.vue');
const approvalNodeList = () => import('components/business/workflow/approval-node-list/index.vue');
import { NativeService } from 'service/native/nativePluginService';
import { dateFormat, decodeBase64, encodeBase64, moneyFormat } from '@/utils/indexV2';
import { getAgentId, getEnvironmentType, getQueryString, isIOS } from '@/utils/environment';
import { mapState, mapGetters } from 'vuex';
import * as ApproveService from '@/service/workflow/approve';
// api
import workflowService from '@/api/workflow/index.js';
import eventService from '@/service/native/eventTrackService';
import workflowHandler from '@/views/workflow/workflow.handler';

import { enterRouterHandle } from 'service/utils/routerHandle';
import { handleDDMsgForward } from 'api/getData';
import { Base64 } from 'js-base64';
import { isPC } from '@/utils/environment';
import config from 'config';
import CustomizeBilibiliService from 'service/customize/bilibili/index';
import util from '@/utils';
import { attachmentLog } from 'service/log/index';
import moment from 'moment';

/*
 * entityType映射
 * */
export const entityTypeMapping = {
  1001: '申请单',
  1002: '报销单',
  3001: '借款单',
  4001: '其他',
  6001: '合同',
  7001: '付款申请单',
  3005: '预算管理',
  9003: '供应商申请',
  3004: '对公支付单',
  1501: '支付单',
  2007: '对公申请单',
  1701: '预提单',
};

/**
 * 所有的组件都放在components中，然后页面无需引入，可以直接使用
 */
export const componentsMixin = {
  components: {
    Swipeout,
    SwipeoutItem,
    SwipeoutButton,
    QuickMenu,
  },
};
/**
 * 公用的filters
 */
export const filtersMixin = {
  filters: {
    formatDate(date, formateStr) {
      return dateFormat(date, formateStr);
    },
    formatChineseDate(date) {
      if (!date) return date;
      let d = new Date(date);
      if (isNaN(d.getTime())) {
        d = moment(date).toDate();
      }
      if (isNaN(d.getTime())) {
        return date;
      }
      let MM = d.getMonth(),
        dd = d.getDate();
      let $t = function (value) {
        let tempObj = [
          window.$t('commonForm-1.key310', { cm: '1月' }),
          window.$t('commonForm-1.key311', { cm: '2月' }),
          window.$t('commonForm-1.key312', { cm: '3月' }),
          window.$t('commonForm-1.key313', { cm: '4月' }),
          window.$t('commonForm-1.key314', { cm: '5月' }),
          window.$t('commonForm-1.key315', { cm: '6月' }),
          window.$t('commonForm-1.key316', { cm: '7月' }),
          window.$t('commonForm-1.key317', { cm: '8月' }),
          window.$t('commonForm-1.key318', { cm: '9月' }),
          window.$t('commonForm-1.key319', { cm: '10月' }),
          window.$t('commonForm-1.key320', { cm: '11月' }),
          window.$t('commonForm-1.key321', { cm: '12月' }),
        ];
        return tempObj[value];
      };
      if (['ch', 'zh', 'zh_cn', 'ja'].includes(window.getSelectedLanguage())) {
        return `${MM + 1}月${dd}日`;
      } else {
        return `${dd} ${$t(MM)}`;
      }
    },
    formatWeekDate(date) {
      if (!date) return date;
      let d = new Date(date);
      if (isNaN(d.getTime())) {
        d = moment(date).toDate();
      }
      if (isNaN(d.getTime())) {
        return date;
      }
      let weeks = [
        window.$t('commonForm-1.key322', { cm: '周日' }),
        window.$t('commonForm-1.key323', { cm: '周一' }),
        window.$t('commonForm-1.key324', { cm: '周二' }),
        window.$t('commonForm-1.key325', { cm: '周三' }),
        window.$t('commonForm-1.key326', { cm: '周四' }),
        window.$t('commonForm-1.key327', { cm: '周五' }),
        window.$t('commonForm-1.key328', { cm: '周六' }),
      ];
      let day = d.getDay();
      return `${weeks[day]}`;
    },
    formatMoney(value, precision) {
      return moneyFormat(value, precision);
    },
    formatOrderType(orderType) {
      switch (orderType) {
        case 'BOOKED':
          return '已订票'; // 已订票
          break;
        case 'REFUNDED':
          return '已退票'; // 已退票
          break;
        case 'TICKETED':
          return '已出票'; // 已出票
          break;
        case 'REBOOKED':
          return '已改签'; // 已改签
          break;
        case 'CHECKOUT':
          return '已离店'; // 已离店
          break;
        case 'OTHER':
          return '其它'; // 其它
          break;
      }
    },
    /**
     * 银行卡号格式化
     * @param {Number || String} code 银行卡号
     * @param {Bool} flag 卡号是否加密
     * @param {Number} figure 需要以几位格式化，默认为4位
     */
    formatBankCode(code, flag = false, figure = 4) {
      if (!code) return '';
      code = ' ' + code.replace(/\s/gm, '');
      let codeAry = [],
        str = '';
      for (let i = 1, len = code.length; i < len; i++) {
        if (i > 4 && i < len - 4 && flag) {
          str += '*';
        } else {
          str += code[i];
        }
        if (i % figure == 0) {
          codeAry.push(str);
          str = '';
        }
      }
      codeAry.push(str);
      return codeAry.join(' ');
    },
  },
};

export const urlParameter = {
  methods: {
    getEnvironmentType: getEnvironmentType,
    getQueryString: getQueryString,
  },
};

/**
 * 公用的vue方法
 */
export const methodsMixin = {
  methods: {
    //页面中所有的方法名称可以走这个方法进行代理
    handle(methodName) {
      if (!methodName) {
        return;
      }
      if (!this[methodName]) {
        return;
      }
      let slice = [].slice,
        restArgs = [...slice.call(arguments, 1)];
      if (restArgs.length > 1) {
        restArgs = [
          {
            args: restArgs,
          },
        ];
      }
      this[methodName].apply(this, restArgs);
    },
    goBack() {
      window.hlyCommon.go(-1);
    },
    showToast(text, options) {
      if (!text) return;
      this.$handPlugin.toast.show(text, options);
    },
    toastSuccess(text) {
      if (text === undefined) {
        text = window.$t('common.key38', { cm: '操作成功' });
      }
      this.showToast(text);
    },
    toastFailure(text) {
      if (text === undefined) {
        text = window.$t('common.key42', { cm: '操作失败' });
      }
      this.showToast(text);
    },
    confirm({
      title,
      content,
      rightButtonText,
      leftButtonText = window.$t('common.key7', { cm: '取消' }),
      leftClick,
      rightClick,
      onHide,
      onShow,
      haveLeft,
    }) {
      if (title == undefined) {
        title = window.$t('common.key46', { cm: '提示' });
      }
      if (rightButtonText == undefined) {
        rightButtonText = window.$t('common.key8', { cm: '确定' });
      }

      this.$handPlugin.confirm.show({
        title: title,
        content: content,
        rightButtonText: rightButtonText,
        leftButtonText: leftButtonText,
        leftClick: leftClick,
        rightClick: rightClick,
        onHide,
        onShow,
        haveLeft,
      });
    },
    /**
     * 统一处理错误的入口方法
     * @param {object} err
     * 超时处理的接口：差补、行程备注提交、银行列表、申请单删除/撤回等
     */
    handleError(err = {}, { timeout = true, useConfirmed = false } = {}) {
      if (err.isCancel) {
        return;
      }
      if (err === 'NON_TOAST') return;
      let errMessage = window.$t('common.key42', { cm: '操作失败' });
      let { response = {}, code, message } = err,
        data = {};
      let { needConfirm, confirmTitle } = data;
      if (timeout && code == 'ECONNABORTED') {
        return this.showToast(window.$t('commonForm-1.key329', { cm: '请求超时，请稍后再试试吧' }));
      }
      if (response.data) {
        data = response.data;
      } else if (err.data) {
        data = err.data;
      }
      if (err.status === -1009 || message === 'Network Error') {
        // 断网的情况
        errMessage = window.$t('commonForm-1.key69', { cm: '网络不给力，请稍后再试试吧' }); //网络不给力，请稍后再试试吧
      } else if (data.errorCode === '6017007') {
        // 试用期过跳到提示页面
        return this.hlyRouter.push({
          name: 'app-expired',
        });
      } else if (data.errorCode === 'OBJECT_NOT_FOUND') {
        errMessage = window.$t('commonForm-1.key330', { cm: '该单据已被员工删除' }); // 该单据已被员工删除
      } else if (response.status == 503) {
        errMessage = window.$t('commonForm-1.key331', { cm: '哎哟，服务器开小差了！' }); // 哎哟，服务器开小差了！
      } else {
        let { message, validationErrors } = data;
        if (message) {
          errMessage = message;
        } else if (typeof err === 'string') {
          errMessage = err;
        }

        if (validationErrors && validationErrors[0]) {
          if (validationErrors[0].message) {
            errMessage = validationErrors[0].message;
          }
          switch (validationErrors[0].message) {
            case 'costCentreOID is null':
              errMessage = '成本中心未选择';
              break;
            case 'departmentOID is null':
              errMessage = '部门未选择';
              break;
            default:
              break;
          }
        }
      }
      if (useConfirmed || needConfirm) {
        this.confirm({
          content: errMessage,
          title: confirmTitle,
        });
      } else {
        this.showToast(errMessage);
      }
    },
    /**
     * 将一个对象转换为base64编码表示
     */
    encodeObjectToBase64(obj = {}) {
      return encodeBase64(JSON.stringify(obj));
    },
    /**
     * 将一个以base64表示的对象字符串转为对象
     */
    decodeBase64ToObject(str) {
      if (!str) return {};
      str = decodeBase64(str);
      if (!str) return {};
      let data = JSON.parse(str);
      return data;
    },
    /**
     * 银行卡号格式化
     * @param {Number || String} code 银行卡号
     * @param {Number} figure 需要以几位格式化，默认为4位
     */
    formatBankCode(code, flag = true, figure = 4) {
      return filtersMixin.filters.formatBankCode.apply(this, arguments);
    },
    /**
     * 刷新首页数据
     * DocStatus 刷新动态单据
     * Approve 刷新审批列表提示数据
     */
    refreshNativeModel(status = 'DocStatus') {
      if (this.$store.getters.isInApp) {
        return NativeService().refreshNativeModel({ modelName: status });
      }
    },
    setTitle(title) {
      NativeService().setTitle(title);
    },
    getTimeZoneLabel(timeZoneOffset, isHead) {
      const getProfile = this.$store.getters.getProfile;
      const showText = getProfile['time.zone.push.adjustment'];
      const text = isHead
        ? window.$t('commonForm-1.key807', { cm: '出发/到达均为当地时间' })
        : window.$t('commonForm-1.key808', { cm: '当地时间' });
      return showText ? text : timeZoneOffset;
    },
  },
};

/**
 * 附件上传方法
 * @type {{methods: {chooseImage(*=, *): void, uploadImage(*=): *, deleteImage(*, *=): void}}}
 */
export const uploadImageMixin = {
  data() {
    return {
      attachmentProgressList: [],
      attachmentProgressListMap: {},
      pushHooks: false,
    };
  },
  methods: {
    /**
     * 选择图片附件方法
     * @param list 当前已选附件
     * @param listMap 附件ID与base64对应的map，用于兼容ios微信wkwebview
     * @param maxNum 最大上传数量
     * @param action 当前执行动作，用于app中判断拍照或从相册中选取
     * @param callBack 选择完图片处理
     * @param attachmentType 附件类型
     * @param key 附件控件id值
     * @param extraData 额外的list参数
     * @param showWatermark 水印展示
     * @param useReportService 使用上报服务
     * @param limitAccept 限制上传的文件类型 可以是单个或多个文件类型 接收类型string|array
     */
    chooseImage(
      list,
      listMap,
      maxNum = 9,
      action,
      callBack,
      attachmentType,
      key = '',
      extraData = {},
      showWatermark = false,
      useReportService = false,
      limitAccept = undefined
    ) {
      // 限制最大上传数量为9
      maxNum = Math.min(maxNum, this.maxLimit ? this.maxLimit : 9);
      let isInApp = this.$store.getters.isInApp,
        listLength = list ? list.length : 0,
        curMaxNum = isInApp ? maxNum - listLength : maxNum - listLength,
        success = (localIds, localData) => {
          attachmentLog(null, '上传附件成功');
          //welink图片上传
          if (localIds && localIds.attachmentOID && getQueryString('loginType') === 'welink') {
            list.push({ ...localIds, ...extraData });
            attachmentLog(null, '上传附件成功1', localIds.attachmentOID);
          } else if (localIds[0].attachmentOID) {
            // 表示已经上传
            localIds.forEach((attachment) => {
              list.push({ ...attachment, ...extraData });
            });
            attachmentLog(null, '上传附件成功2', localIds[0].attachmentOID);
          } else {
            localIds.forEach((url) => {
              list.push({
                attachmentOID: '',
                fileURL: url,
                fileType: 'IMAGE',
                ...extraData,
              });
            });
            attachmentLog(null, '上传附件成功3 url');
          }
          // // ios微信端wkwebview兼容性处理
          // if (localData && localData.length > 0) {
          //     listMap[localData.localId] = localData.localData;
          // }
          // ios微信端wkwebview兼容性处理
          if (localData && localData.length > 0) {
            localData.forEach((data) => {
              if (data) {
                listMap[data.localId] = data.localData;
              }
            });
          }
          this.resetAttachmentProgressList(key);
          callBack && callBack();
        },
        error = (err) => {
          attachmentLog(null, '上传附件失败');
          attachmentLog(err);
          this.resetAttachmentProgressList(key);
          if (err) {
            if (err.response && err.response.data && err.response.data.message) {
              this.$handPlugin.toast.show(err.response.data.message);
            } else {
              this.$handPlugin.toast.show(err);
            }
          }
        },
        pending = (progress) => {
          if (key) {
            this.attachmentProgressListMap[key] = progress;
          } else {
            this.attachmentProgressList = progress;
          }
          if (!this.pushHooks) {
            this.$router.beforeHooks.push((to, from, next) => {
              if (this.attachmentProgressList.length) {
                this.cancelUploadingAttachment(key);
              } else {
                this.$router.beforeHooks.pop();
                this.pushHooks = false;
              }
              next();
            });
            this.pushHooks = true;
          }
        };

      // ios只会执行最新的回调 2.20.0修复 前端兼容处理
      if (
        isInApp &&
        isIOS() &&
        this.COMMON.versionEnable('2.20.0') &&
        Object.keys(this.attachmentProgressListMap).some((key) => this.attachmentProgressListMap[key].length > 0)
      ) {
        this.$handPlugin.toast.show(window.$t('global-1.key257', { cm: '正在上传中，请稍后' }));
        return !1;
      }
      attachmentLog(null, '开始进程附件========');
      NativeService().getLocalImgData(
        success,
        error,
        curMaxNum,
        undefined,
        action,
        pending,
        undefined,
        {},
        limitAccept,
        showWatermark,
        useReportService
      );
    },
    uploadImage(list, staticEnable) {
      return new Promise((resolve, reject) => {
        let needUploadImg = [],
          uploadImgIndexMap = [];
        list.forEach((item, index) => {
          if (
            item.fileURL.substr(0, 2) === 'wx' ||
            item.fileURL.substr(0, 6) === 'weixin' ||
            item.fileURL.substr(0, 3) === 'img' ||
            item.fileURL.substr(0, 13) === 'http://static' ||
            item.fileURL.substr(0, 14) === 'https://static'
          ) {
            needUploadImg.push(item.fileURL);
            uploadImgIndexMap.push(index);
          }
        });
        let context = this,
          params = {
            attachmentType: 'INVOICE_IMAGES',
            companyOID: context.$store.getters.getMyInfo.companyOID,
            corpId: context.getQueryString('corpId') || sessionStorage.getItem('corpId'),
            suiteId: context.getQueryString('suiteId'),
            userOID: context.$store.getters.getMyInfo.userOID,
            needUploadImg,
            successCount: 0,
            isPublic: true,
          };

        this.loadingText = window.$t('commonForm-1.key332', {
          arg1: params.successCount + 1,
          total: needUploadImg.length,
          arg2: needUploadImg.length,
          cm: '正在上传图片... ({arg1}/{arg2})',
        });
        NativeService().uploadImage(
          params,
          (successImgList) => {
            successImgList.forEach((item, index) => {
              list[uploadImgIndexMap[index]].attachmentOID = item.attachmentOID;
              list[uploadImgIndexMap[index]].fileURL = item.fileURL;
            });
            resolve();
          },
          (successImgList, e) => {
            let errMsg;
            if (Array.isArray(successImgList)) {
              // 微信逐张上传，所以存在部分图片上传成功情况
              let wxErrorMsg = e.response && e.response.data && e.response.data.message;
              errMsg = e.errMsg || e.status || wxErrorMsg || '';
              this.$handPlugin.toast.show(
                window.$t('commonForm-1.key333', { arg1: successImgList.length + 1, cm: '第{arg1}张图片上传失败' }) +
                  ': ' +
                  errMsg
              );
            } else {
              // 此时successImgList为返回的异常信息
              errMsg = successImgList.name ? successImgList.name + ':' + successImgList.message : '';
              this.$handPlugin.toast.show(errMsg);
              this.showLoading = false;
            }
            reject(errMsg);
          },
          [],
          staticEnable
        );
      });
    },
    deleteImage(list, index, img) {
      if (typeof index === 'boolean') {
        list.splice(
          list.findIndex(
            (item) =>
              item.thumbnailUrl === img.src ||
              item.fileURL === img.src ||
              item.thumbnailUrl === img.fileURL ||
              item.fileURL === img.fileURL
          ),
          1
        );
      } else {
        list.splice(index, 1);
      }
    },
    isUploadingAttachment() {
      if (
        this.attachmentProgressList.length ||
        Object.keys(this.attachmentProgressListMap).some((key) => this.attachmentProgressListMap[key].length > 0)
      ) {
        this.$handPlugin.toast.show(window.$t('commonForm-1.key334', { cm: '正在上传图片，请稍后' }));
        return true;
      } else {
        return false;
      }
    },
    cancelUploadingAttachment(key = '') {
      NativeService().cancelUploadingAttachment();
      this.resetAttachmentProgressList(key);
    },
    resetAttachmentProgressList(key = '') {
      if (key) {
        this.attachmentProgressListMap[key] = [];
      } else {
        this.attachmentProgressList = [];
      }
      if (this.pushHooks) {
        this.$router.beforeHooks.pop();
        this.pushHooks = false;
      }
    },
  },
};

/**
 * 差旅要素处理
 */
export const oldTravelMixin = {
  methods: {
    otherTicketStoreSet(dataStore) {
      dataStore.isShowStartDate = true;
      dataStore.isShowOtherTraffic = false;
      dataStore.isShowTrafficType = false;
      dataStore.isShowRemark = false;
      dataStore.serviceName = 'standard';
      dataStore.startDateText = '出行日期';
    },
    otherTicketValidate({ fromCity, toCity, startDate, getProfile }) {
      if (!fromCity) {
        return '请选择其它交通行程的出发地';
      } else if (!toCity) {
        return '请选择其它交通行程的目的地';
      } else if (!getProfile['ca.travel.other.support.same.city'] && fromCity === toCity) {
        return '其它交通行程的出发地和目的地不能相同';
      } else if (!startDate) {
        return '请选择其它交通行程的出发时间';
      }
    },

    trainTicketStoreSet(dataStore) {
      // 是否显示出发城市
      dataStore.isShowFromCity = true;
      // 是否显示到达城市
      dataStore.isShowToCity = true;
      //  是否显示出发日期
      dataStore.isShowStartDate = true;
      // 是否显示舱位
      dataStore.isShowSeatClass = false;
      // 是否显示价格
      dataStore.isShowTicketPrice = false;
      // 是否显示备注
      dataStore.isShowRemark = false;

      dataStore.serviceName = 'standard';
      dataStore.startDateText = '出行日期';
    },
    trainTicketValidate({ fromCity, toCity, startDate }) {
      if (!fromCity) {
        return '请输入火车行程的出发地';
      } else if (!toCity) {
        return '请输入火车行程的目的地';
      } else if (fromCity === toCity) {
        return '火车行程的出发地和目的地不能相同';
      } else if (!startDate) {
        return '请输入火车行程的出发时间';
      }
    },

    flightTicketStoreSet(dataStore) {
      this.localTabEnable = false;
      dataStore.isShowFromCity = true;
      dataStore.isShowToCity = true;
      dataStore.isShowStartDate = true;
      dataStore.isSingleDate = true;
      dataStore.isShowEndDate = false;
      dataStore.isShowTime = false;
      dataStore.isShowTakeOffTime = false;
      dataStore.isShowArrivalTime = false;
      dataStore.isShowAirLine = false;
      dataStore.isShowSeatClass = false;
      dataStore.isShowDiscount = false;
      dataStore.isShowTicketPrice = false;
      dataStore.isShowRemark = false;
      dataStore.isShowTab = false;

      dataStore.serviceName = 'ctrip_air';
      dataStore.startDateText = '出行日期';
    },
    flightTicketValidate({ fromCity, toCity, startDate }) {
      // 验证出发城市
      if (!fromCity) {
        return '请输入飞机行程的出发地';
        // 验证目的地
      } else if (!toCity) {
        return '请输入飞机行程的目的地';
      } else if (fromCity === toCity) {
        return '飞机行程的出发地及目的地不能相同';
      } else if (!startDate) {
        return '请选择飞机行程的出发时间';
      }
    },
  },
};

/**
 * 添加按钮动画处理
 */
let winHeight = window.innerHeight,
  winWidth = window.innerWidth,
  innerPadding = 45;
export const btnMoveMixin = {
  data() {
    return {
      posTimer: null,
      isDragging: false, // 是否处于拖拽状态
      dragTimer: null,
      addTravelBtnPos: {
        x: 0,
        y: 0,
      },
    };
  },
  methods: {
    // 还原添加按钮的位置
    resetAddtravelBtnPos($dom) {
      $dom.ontouchmove = null;
      $dom.ontouchend = null;
      $dom.style.transition = 'all 0.3s ease-in-out';
      $dom.style.transform = 'translate3D(0,0,0)';
      this.addTravelBtnPos = {
        x: 0,
        y: 0,
      };
      setTimeout(() => {
        $dom.style.transition = null;
      }, 400);
    },
    /**
     * @description: 拖拽事件 pc 和 app通用
     * @param {*} e 当前操作元素
     * @param {*} id 指定Dom元素id 不传默认获取当前操作元素
     * @param {*} fixed 某方向上固定不允许拖动 fixedX X轴方向固定 fixedY Y轴方向固定
     * @param {*} needReset 是否需要重置按钮位置
     * @return {*}
     */
    DRAG_EVENT(e, id, fixed = {}, needReset = false) {
      const initialMouseX = e.clientX || e.touches[0].clientX;
      const initialMouseY = e.clientY || e.touches[0].clientY;
      let $target = id ? document.getElementById(id) : e.target;
      const $dom = ['IMG', 'svg'].includes($target.tagName)
        ? $target.parentNode
        : $target.tagName === 'use'
        ? $target.parentNode.parentNode
        : $target;
      if (!this.addTravelBtnPos.x && !this.addTravelBtnPos.y) {
        this.addTravelBtnPos = {
          x: initialMouseX,
          y: initialMouseY,
        };
      }
      // 处理拖拽
      const doDrag = (moveEvent) => {
        this.isDragging = true;
        const { fixedX, fixedY } = fixed || {};
        let currentPosX = moveEvent.clientX || moveEvent?.touches[0]?.clientX || 0;
        let currentPosY = moveEvent.clientY || moveEvent?.touches[0]?.clientY || 0;
        // 只限定在一定范围内移动
        if (currentPosX < innerPadding) {
          currentPosX = innerPadding;
        } else if (currentPosX > winWidth - innerPadding) {
          currentPosX = winWidth - innerPadding;
        }
        if (currentPosY < innerPadding) {
          currentPosY = innerPadding;
        } else if (currentPosY > winHeight - innerPadding) {
          currentPosY = winHeight - innerPadding;
        }
        let diffX = fixedX ? 0 : currentPosX - this.addTravelBtnPos.x,
          diffY = fixedY ? 0 : currentPosY - this.addTravelBtnPos.y;
        $dom.style.transform = `translate3D(${diffX}px,${diffY}px,0)`;
        if (this.posTimer) {
          clearTimeout(this.posTimer);
          this.posTimer = null;
        }
        if (this.dragTimer) {
          clearTimeout(this.dragTimer);
          this.dragTimer = null;
        }
      };

      // 每次结束拖拽移除监听事件
      const stopDrag = (e) => {
        e.stopPropagation();
        if (needReset) {
          this.posTimer = setTimeout(() => this.resetAddtravelBtnPos($dom), 5000);
        }
        // isDragging 重置拖拽状态
        this.dragTimer = setTimeout(() => {
          this.isDragging = false;
        }, 300);
        document.removeEventListener('mousemove', doDrag);
        document.removeEventListener('touchmove', doDrag);
        document.removeEventListener('mouseup', stopDrag);
        document.removeEventListener('touchend', stopDrag);
      };
      document.addEventListener('mousemove', doDrag);
      document.addEventListener('touchmove', doDrag);
      document.addEventListener('mouseup', stopDrag);
      document.addEventListener('touchend', stopDrag);
      this.setFirstImportExpense && this.setFirstImportExpense('N');
    },
    onBtnTouchStart($event) {
      let $target = $event.target,
        $dom = ['IMG', 'svg'].includes($target.tagName)
          ? $target.parentNode
          : $target.tagName === 'use'
          ? $target.parentNode.parentNode
          : $target,
        touch = $event.touches[0],
        initPosX = touch.pageX || touch.clientX,
        initPosY = touch.pageY || touch.clentY;
      if (!this.addTravelBtnPos.x && !this.addTravelBtnPos.y) {
        this.addTravelBtnPos = {
          x: initPosX,
          y: initPosY,
        };
      }

      $dom.ontouchmove = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let touch = e.touches[0],
          currentPosX = touch.pageX || touch.clientX,
          currentPosY = touch.pageY || touch.clientY;
        // 只限定在一定范围内移动
        if (currentPosX < innerPadding) {
          currentPosX = innerPadding;
        } else if (currentPosX > winWidth - innerPadding) {
          currentPosX = winWidth - innerPadding;
        }
        if (currentPosY < innerPadding) {
          currentPosY = innerPadding;
        } else if (currentPosY > winHeight - innerPadding) {
          currentPosY = winHeight - innerPadding;
        }
        let diffX = currentPosX - this.addTravelBtnPos.x,
          diffY = currentPosY - this.addTravelBtnPos.y;
        $dom.style.transform = `translate3D(${diffX}px,${diffY}px,0)`;
      };
      if (this.posTimer) {
        clearTimeout(this.posTimer);
        this.posTimer = null;
      }
      $dom.ontouchend = (e) => {
        e.stopPropagation();
        this.posTimer = setTimeout(() => this.resetAddtravelBtnPos($dom), 5000);
      };

      this.setFirstImportExpense && this.setFirstImportExpense('N');
    },
  },
};

/**
 * 原生缓存更新处理
 */
export const webviewRefreshMixin = {
  data() {
    return {
      WEBVIEW_REFRESH_INITED: false,
      ...mapState([
        // 保存当前Refresh函数，避免二次注册
        'webviewRefreshListener',
      ]),
      currentPageName: '',
    };
  },
  methods: {
    ON_WK_WEBVIEW_REFRESH() {
      let key = this.$route.name;
      if (key === this.currentPageName) {
        this._onWkWebviewRefresh();
        enterRouterHandle(this.$route);
        /*
        if (this.$route.meta.code) {
          key = this.$route.meta.code;
        }
        key = "title." + key;

        if (key !== "title.null") {
          let title = this.$t(key) || "汇联易";
          NativeService().setTitle(title);
        }*/
      }
    },
  },
  activated() {
    /**
     * 需要在混入页面注册刷新回调方法 _onWkWebviewRefresh
     */
    if (!this._onWkWebviewRefresh) {
      return;
    }
    // // 移除之前的监听
    // document.body.removeEventListener('WEBVIEW_REFRESH', this.ON_WK_WEBVIEW_REFRESH)
    // 注册监听
    if (!this.WEBVIEW_REFRESH_INITED) {
      this.WEBVIEW_REFRESH_INITED = true;
      this.currentPageName = this.$route.name;
      document.body.removeEventListener('WEBVIEW_REFRESH', this.ON_WK_WEBVIEW_REFRESH);
      document.body.addEventListener('WEBVIEW_REFRESH', this.ON_WK_WEBVIEW_REFRESH);
    }
    return;
  },
};

/**
 * 用于处理弹框时避免iOS滚动穿透
 * forbid-scroll为body添加了position: fixed
 *
 * 在为body添加fixed之后，再在DOM中渲染fixed元素会出现未渲染的bug，所以需要先调用_removeForbidClass
 * 然后在元素渲染完成之后再调用_addForbidClassOnly或_addForbidClass
 *
 * window._forbidScrollNum用来标记是否需要添加forbid-scroll
 * 类似弹框或弹出选择时需要添加，避免滚动穿透，普通fixed元素不需要添加
 *
 * @type {{methods: {_removeForbidClass(): void, _addForbidClassOnly(): void, _addForbidClass(): void, _reduceForbidClass(): void}}}
 */
export const forbidScrollMixin = {
  methods: {
    _removeForbidClass() {
      if (document.body.classList.contains('forbid-scroll')) {
        document.body.classList.remove('forbid-scroll');
      }
    },
    _addForbidClassOnly() {
      if (!document.body.classList.contains('forbid-scroll') && window._forbidScrollNum) {
        document.body.classList.add('forbid-scroll');
      }
    },

    _addForbidClass() {
      if (!document.body.classList.contains('forbid-scroll')) {
        document.body.classList.add('forbid-scroll');
      }

      if (window._forbidScrollNum === undefined) {
        window._forbidScrollNum = 1;
      } else {
        window._forbidScrollNum++;
      }
    },
    _reduceForbidClass() {
      if (window._forbidScrollNum > 0) {
        window._forbidScrollNum--;
      }

      if (window._forbidScrollNum === 0) {
        if (document.body.classList.contains('forbid-scroll')) {
          document.body.classList.remove('forbid-scroll');
        }
      }
    },
  },
};

export const hideModalMixin = {
  beforeRouteLeave(to, from, next) {
    let { state, commit } = this.$store;

    if (window._isBacking) {
      if (state.openingModals && state.openingModals.length) {
        commit('popOpeningModal');
        window._isBacking = false;
        // 取消app的延时关闭判断
        window.closeAppTimeout && clearTimeout(window.closeAppTimeout);
        next(false);
      } else {
        next();
      }
    } else {
      commit('clearOpeningModal');
      next();
    }
  },
};

// 审批链信息处理
export const approvalChainInfoMixin = {
  data() {
    return {
      showApporvalCancel: false,
      currentApprovalChainInfoV2: {},
    };
  },
  computed: {
    // 当前审批流状态
    currentApprovalChainInfo() {
      let {
          applicationDetail,
          commonDocDetail,
          expenseClaimData,
          loanBillData,
          getMyInfo,
          paymentRequestData,
          corpPaymentDetail,
          budgetJournalDetail,
          supplierDetail,
          contractDetail,
          accrualDetail,
          detail,
        } = this,
        detailData =
          applicationDetail ||
          commonDocDetail ||
          expenseClaimData ||
          loanBillData ||
          paymentRequestData ||
          corpPaymentDetail ||
          budgetJournalDetail ||
          supplierDetail ||
          contractDetail ||
          accrualDetail ||
          detail ||
          {},
        { status, approvalChain, approvalChains } = detailData,
        userOID = getMyInfo.userOID;
      let { isCurrentApprover, isPending, currentNodeOID, entityOID, entityType, version } =
        ApproveService.handleApprovalChain(approvalChain, approvalChains, userOID, status);
      return { isCurrentApprover, isPending, currentNodeOID, entityOID, entityType, version };
    },
    // 是否为暂挂状态
    isPending() {
      let { currentApprovalChainInfo } = this;
      return currentApprovalChainInfo.isPending;
    },
  },
  methods: {
    initCurrentApprovalChainInfo(approvalChain, approvalChains, userOID, status) {
      this.currentApprovalChainInfoV2 = ApproveService.handleApprovalChain(
        approvalChain,
        approvalChains,
        userOID,
        status
      );
    },
    initCancelApprovalStatus(entityOID, entityType) {
      if (this.COMMON.getOption('approvalFunctionOpt.approvalCancelEnabled') === true) {
        const params = {
          entityOID,
          entityType,
        };
        workflowService.showApporvalCancel(params).then((res) => {
          this.showApporvalCancel = this.COMMON.getValue(res.data, 'showApporvalCancel');
        });
      }
    },
    onApprovalCancelClicked(entityOID, entityType) {
      this.$handPlugin.confirm.show({
        title: window.$t('commonForm-1.key336', { cm: '确定要取消审批吗？' }),
        leftButtonText: window.$t('common.key7', { cm: '取消' }),
        rightButtonText: window.$t('common.key8', { cm: '确定' }),
        rightClick: () => {
          this.updateIsShowLoading(true);
          const params = {
            entityOID,
            entityType,
          };
          workflowService
            .approvalCancel(params)
            .then((res) => {
              this.updateIsShowLoading(false);
              this.localInit(true);
            })
            .catch((error) => {
              this.updateIsShowLoading(false);
              this.COMMON.errorHandle(error, window.$t('commonForm-1.key337', { cm: '取消审批失败' }));
            });
        },
        leftClick: () => {},
      });
    },
  },
};

//渲染完成前 把localStorage的历史选择城市进行翻译
export const transferFormMixin = {
  components: {
    approvalNodeList,
  },
  data() {
    return {
      transferButtons: [
        {
          title: window.$t('commonForm-1.key540', { cm: '转发到钉钉' }),
          key: 'shareToDingTalk',
        },
        {
          title: window.$t('commonForm-1.key541', { cm: '转发到飞书' }),
          key: 'shareToLark',
        },
        {
          title: window.$t('commonForm-1.key544', { cm: '转发到企微' }),
          key: 'shareToWeCom',
        },
      ],
      wxGroupChatBtn: { title: window.$t('commonForm-1.key615', { cm: '发起群聊' }), key: 'handleWxGroupChat' },
      showGroupChatModal: false,
    };
  },
  computed: {
    ...mapState(['companyConfigurations', 'storesWeCom']),
    ...mapGetters(['getMyInfo', 'getProxyOptions']),
    isDDTransfer() {
      return (
        this.companyConfigurations &&
        this.companyConfigurations.dingtalkMsgTransferMark &&
        getQueryString('loginType') === 'dd'
      );
    },
    isLarkTransfer() {
      return (
        this.companyConfigurations &&
        this.companyConfigurations.feishuMsgTransferMark &&
        getQueryString('loginType') === 'feishu' &&
        this.COMMON.getValue(this.getProxyOptions, 'thirdCorpOptions.feishuUserHadBound')
      );
    },
    isWeComTransfer() {
      return (
        this.companyConfigurations &&
        this.companyConfigurations.wechatMsgTransferMark &&
        // this.storesWeCom &&
        CustomizeBilibiliService.isWxGroupChatByLoginType()
      );
    },
  },
  methods: {
    showChannel(propertyMap, platform) {
      let channels =
        (util.isJsonStr(propertyMap)
          ? JSON.parse(propertyMap['pull.channel'])
          : propertyMap && propertyMap['pull.channel']) ||
        (this.groupChatList && JSON.parse(this.groupChatList));
      if (util.isJsonStr(channels)) {
        channels = JSON.parse(channels);
      }
      return Array.isArray(channels) ? !!channels.length && channels.indexOf(platform) > -1 : !channels;
    },
    // 企微不能发起飞书群聊
    checkHide(hideList) {
      return hideList && hideList.includes(getQueryString('loginType'));
    },
    isInLarkGroupChat(propertyMap) {
      if (this.checkHide(['dd', 'wx'])) return false;
      // 仅飞书移动端展示
      // let showInLarkApp = ['Mobile', 'Lark'].every((key) => navigator.userAgent.includes(key));
      // let showInMobile = navigator.userAgent.includes('Mobile');
      return (
        this.COMMON.getValue(this.getProxyOptions, 'thirdCorpOptions.feishuUserHadBound') &&
        this.showChannel(propertyMap, 'lark')
      );
    },
    isInWechatGroupChat(propertyMap) {
      if (this.checkHide(['dd', 'feishu'])) return false;
      //先针对自建应用和B站放开，自建应用的判断后面会调整
      let locationUrl = window.location.href;
      let showGroupFlag = getAgentId();
      showGroupFlag =
        (config.env === 'prod' && (getAgentId() || locationUrl.indexOf('expensewebapp.bilibili') > -1)) ||
        config.env !== 'prod';
      return (
        showGroupFlag && CustomizeBilibiliService.isWxGroupChatByLoginType() && this.showChannel(propertyMap, 'wechat')
      );
    },
    isWxGroupChat(propertyMap, type) {
      return (
        (this.isInLarkGroupChat(propertyMap) || this.isInWechatGroupChat(propertyMap)) &&
        this.$route.name !== 'workflow-list' &&
        ((this.$route.query.pageFlag !== 'approval' && type === 'notApproval') ||
          (this.$route.query.pageFlag === 'approval' && !type))
      );
    },
    recordEventService({ entityType, formType, platformName }) {
      let formTypeName = workflowHandler.getFormName(`${formType}`);
      if (`${formTypeName}` === `${formType}`) {
        formTypeName = entityTypeMapping[+entityType] || formType;
      }
      const eventParams = {
        formTypeName,
        platformName: `${platformName}H5端`,
        tenantName: this.getMyInfo.tenantName,
      };
      eventService['inf-00000030'](eventParams);
      window._helios_track_event && window._helios_track_event.report();
    },
    shareToDingTalk(entityOID, entityType, formType) {
      NativeService().pickConversation(
        (response) => {
          let params = {
            cid: response.cid,
            entityOID,
            entityType,
            platform: 'DING_DING',
          };
          const appKey = getQueryString('appKey');
          if (appKey) {
            params.appKey = appKey;
          }
          this.$plugins.showLoading();
          handleDDMsgForward(params)
            .then(() => {
              this.recordEventService({ entityType, formType, platformName: '钉钉' });
              this.$plugins.hideLoading();
              this.showToast(window.$t('commonForm-1.key543', { cm: '发送成功' }));
            })
            .catch((err) => {
              this.$plugins.hideLoading();
              this.handleError(err);
            });
        },
        () => {
          this.$plugins.hideLoading();
        }
      );
    },
    shareToLark(entityOID, entityType, formType) {
      if (isPC() && !navigator.userAgent.includes('WebApp/sidebar')) {
        this.showToast(window.$t('commonForm-1.key804', { cm: '飞书审批嵌入页面暂不支持转发，可通过移动端操作' }));
        return;
      }
      this.$plugins.showLoading();
      handleDDMsgForward({
        entityOID,
        entityType,
        platform: 'FEI_SHU',
      })
        .then((res) => {
          if (res.data.code === '0000') {
            this.$plugins.hideLoading();
            NativeService().sendMessageCard(
              () => {
                this.recordEventService({ entityType, formType, platformName: '飞书' });
                this.showToast(window.$t('commonForm-1.key543', { cm: '发送成功' }));
              },
              (err) => {
                this.handleError(err);
              },
              JSON.parse(Base64.decode(res.data.data.messageContent))
            );
          }
        })
        .catch((err) => {
          this.$plugins.hideLoading();
          this.handleError(err);
        });
    },
    shareToWeCom(entityOID, entityType, formType) {
      //下面处理吧…… 接力棒 交接 (＾Ｕ＾)ノ~ＹＯ
      this.$plugins.showLoading();
      handleDDMsgForward({
        entityOID,
        entityType,
        platform: 'WECHAT',
      })
        .then((res) => {
          if (res.data.code === '0000') {
            this.$plugins.hideLoading();
            let cardContent = JSON.parse(Base64.decode(res.data.data.messageContent));
            // NativeService()[this.storesWeCom ? 'createChatWithMsg' : 'shareAppMessage'](
            NativeService().shareAppMessage(
              (res) => {
                //成功
                this.recordEventService({ entityType, formType, platformName: '企微' });
                if (isIOS()) {
                  this.showToast(window.$t('commonForm-1.key543', { cm: '发送成功' }));
                }
              },
              (err) => {
                //失败
                if (err && err.err_msg === 'createChatWithMsg:cancel') {
                  //用户主动取消了分享
                }
              },
              cardContent
              // {
              //   ...cardContent,
              //   imgUrl:
              //     'https://cloudhelios-static.oss-cn-shanghai.aliyuncs.com/other/1bc8b7de-8ac7-4baf-9c7d-3d798561c5e9-1573813742713.png',
              // }
            );
          }
        })
        .catch((err) => {
          this.$plugins.hideLoading();
          this.handleError(err);
        });
    },
    addTransferMoreActionMenusOld(actionMenus, status) {
      if (status !== 1001) {
        this.isDDTransfer && actionMenus.push(this.transferButtons[0]);
        this.isLarkTransfer && actionMenus.push(this.transferButtons[1]);
        this.isWeComTransfer && actionMenus.push(this.transferButtons[2]);
      }
    },
    addTransferMoreActionMenus(actionMenus, status, propertyMap, type) {
      if (status !== 1001) {
        if (type !== 'accrual') {
          this.isDDTransfer && actionMenus.push(this.transferButtons[0]);
          this.isLarkTransfer && actionMenus.push(this.transferButtons[1]);
          this.isWeComTransfer && actionMenus.push(this.transferButtons[2]);
        }
        if (this.isWxGroupChat(propertyMap, 'notApproval')) {
          const btnConfig = Object.assign({}, this.wxGroupChatBtn);
          if (this.isInLarkGroupChat(propertyMap)) {
            btnConfig.title = window.$t('commonForm-1.key767', { cm: '发起飞书群聊' });
          } else if (this.isInWechatGroupChat(propertyMap)) {
            btnConfig.title = window.$t('commonForm-1.key768', { cm: '发起企微群聊' });
          }
          actionMenus.push(btnConfig);
        }
      }
    },
    handleWxGroupChat() {
      /*
      // 飞书申请授权后拉群
      if (getQueryString('loginType') === 'feishu') {
        NativeService()
          .applyTenantAppScope('im:chat')
          .then(() => {
            this.showGroupChatModal = true;
          });
        return;
      }
      */
      // 发起群聊
      this.showGroupChatModal = true;
    },
    closeNodeList() {
      this.showGroupChatModal = false;
    },
  },
};
